import React, { useEffect, useId } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSquareCheck } from '@fortawesome/free-solid-svg-icons';
import { faSquare } from '@fortawesome/free-regular-svg-icons';

export const Checkbox = ({ label, checked: initialState, onChange }) => {
  const [checked, setChecked] = React.useState(initialState);
  const id = useId();

  useEffect(() => {
    onChange(checked);
  }, [checked]);

  return (
    <>
      <input
        id={id}
        className="peer hidden"
        type="checkbox"
        checked={checked}
        onChange={(e) => setChecked(e.target.checked)}
      />
      <label htmlFor={id} className="grid w-full grid-cols-[30px_auto] items-center gap-x-2 hover:cursor-pointer">
        <div className="relative col-start-1 row-start-1">
          <FontAwesomeIcon
            icon={faSquareCheck}
            className="text-pdteal absolute top-1/2 left-1/2 col-start-1 row-start-1 -translate-1/2 opacity-0 drop-shadow-md transition-opacity data-[checked=true]:opacity-100"
            data-checked={checked}
          />
          <FontAwesomeIcon
            icon={faSquare}
            className="text-pdteal absolute top-1/2 left-1/2 col-start-1 row-start-1 -translate-1/2 opacity-100 transition-opacity data-[checked=true]:opacity-0"
          />
        </div>
        <div className="col-start-2 row-start-1 hover:cursor-pointer">
          <span className="font-normal">{label}</span>
        </div>
      </label>
    </>
  );
};
